// extracted by mini-css-extract-plugin
export default {"Spinner":"hkBh4X89","Centered":"KGNpIdKA"};